import { createAction } from 'redux-actions';
import { getMultipleElementsFromCache } from 'store/actions/element-cache-actions';
import { selectMultipleElementsContentPanel } from 'store/actions/action-creators';

import { showBatchPanelAction } from 'store/actions/panel-controller-actions';
import { RIGHT_PANELS } from 'constants/feature/panel-constants';

import { batchMaxAmountNotification } from 'utils/batch-panel-utils';
import { getMaxElementForBatchUpdateLimit } from 'utils/statement-content-page-utils';
import {
  TRAIL_BALANCE_MODE,
  SIDE_BY_SIDE_COMPARE_MODE,
  AUTO_TIEOUT_COMPARE_MODE,
} from 'constants/feature/statement-content-constants';

export const addElementToBatchSelectionAction = createAction(
  'BATCH_ADD_ELEMENT_TO',
);
export const setBatchSelectedElementsLoading = createAction(
  'BATCH_ELEMENTS_LOADING',
);
export const appendBatchSelectedElementsLoaded = createAction(
  'BATCH_APPEND_ELEMENTS_LOADED',
);
export const _handleBatchAddWithElementAlreadySelected =
  () => (dispatch, getState) => {
    const {
      ui: {
        statementPage: {
          panels: { right },
        },
      },
      data: {
        statementContent: { elementCache },
        elementPanel: { elementDetails },
      },
    } = getState();
    if (right === RIGHT_PANELS.ELEMENT) {
      // with element panel open + batch click, switch to batch panel with that element selected
      let element =
        elementDetails &&
        elementDetails.isLoaded && // element with id 0 is considred as falsy hence it is return 0 and that's why this explicit check is added
        // getElement method inside section-cache model mandatorily needs elementID to get element details.
        // if sectionId is null then it will search in all the sections present in the cache.
        elementCache.getElement({
          elementId: elementDetails.id,
          sectionId: elementDetails.sectionId,
        });
      element &&
        dispatch(
          addElementToBatchSelectionAction({
            element,
          }),
        );
    }
  };

export const batchAddElementsToBatch =
  ({ elements }) =>
  async (dispatch, getState) => {
    const {
      data: {
        batchPanel: {
          batchElementList: { selectedElementIds },
        },
      },
      ui: {
        statementPage: {
          panels: { right },
        },
        sideBySideView: {
          sideBySideViewMode: { viewMode },
        },
      },
    } = getState();

    const maxLimitKey =
      viewMode === TRAIL_BALANCE_MODE || viewMode === AUTO_TIEOUT_COMPARE_MODE
        ? 'payloadBatch'
        : null;
    const maxLimit = getMaxElementForBatchUpdateLimit(maxLimitKey);

    if (selectedElementIds.length + 1 <= maxLimit) {
      dispatch(_handleBatchAddWithElementAlreadySelected());
    }
    if (selectedElementIds.length + elements.length <= maxLimit) {
      // always select all the elements in the content panel
      dispatch(
        selectMultipleElementsContentPanel({
          elementIds: elements.map((el) => el.elementId),
        }),
      );
      if (
        !right !== RIGHT_PANELS.BATCH &&
        viewMode !== SIDE_BY_SIDE_COMPARE_MODE
      ) {
        dispatch(showBatchPanelAction());
      }
      const selectedElements = await dispatch(
        getMultipleElementsFromCache({
          elements,
          loadingAction: setBatchSelectedElementsLoading,
        }),
      );
      dispatch(appendBatchSelectedElementsLoaded({ selectedElements }));
    } else {
      batchMaxAmountNotification(maxLimitKey);
    }
  };
